/******************************************************************************
 * Created Date: Friday March 4th 2022                                        *
 * Author: Patrick B.                                                         *
 * -----                                                                      *
 * Last Modified: Fri Mar 04 2022                                             *
 * Modified By: Patrick B.                                                    *
 * -----                                                                      *
 * File: /src/components/algorithms/quantification/UtcTimer.js                *
 * Copyright (c) 2022 Kuva                                                    *
 ******************************************************************************/

import { useState, useEffect } from "react";
import { Typography } from "@mui/material";
import { utcToZonedTime } from "date-fns-tz";

const UtcTimer = ({ utcZone }) => {
  const [utcTime, setUtcTime] = useState(utcToZonedTime(new Date(), utcZone));

  useEffect(() => {
    const interval = setInterval(() => {
      setUtcTime(utcToZonedTime(new Date(), utcZone));
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <Typography variant="subtitle2">{utcTime.toLocaleString()}</Typography>
  );
};

export default UtcTimer;
